import { Directive } from '@angular/core';

/**
 * Marks host-projected content that replaces the built-in option list in {@link CadsSelectComponent} when the panel is
 * expanded. Use for virtualized lists, rich rows, or any custom markup; wire selection by calling
 * {@link CadsSelectComponent.selectOptionValue} (template ref) or by binding the parent `FormControl`.
 */
@Directive({
  selector: '[cadsSelectOptions]',
  standalone: true,
})
export class CadsSelectOptionsSlotDirective {}
